import type { ComponentType } from 'react';
import { createContext } from 'react';

export interface WithSectionContextProps {
  section: string;
}

export const SectionContext = createContext('');
export const SectionProvider = SectionContext.Provider;
export const SectionConsumer = SectionContext.Consumer;
export default SectionContext;

// HOC for convenience...
export const withSectionContext =
  <TProps extends WithSectionContextProps>(
    Component: ComponentType<TProps>
  ): ComponentType<Omit<TProps, keyof WithSectionContextProps>> =>
  (props: Omit<TProps, keyof WithSectionContextProps>) => {
    return (
      <SectionConsumer>
        {section => <Component {...(props as TProps)} section={section} />}
      </SectionConsumer>
    );
  };
